import {
  Tree,
  TreeCheckboxSelectionKeys,
  TreeSelectionEvent,
} from "primereact/tree";
import { useState, useMemo } from "react";
import "primereact/resources/themes/md-light-indigo/theme.css";
import { Category } from "./RestrictedCategories";
import { TreeNode } from "primereact/treenode";
import { useTranslation } from "../../../../../hooks/useTranslation";

type CategorySelectProps = {
  categories: Category[];
  onSelectionChange: (_selectedIds: string[]) => void;
};

const transformData = (data: Category[]): TreeNode[] => {
  return data.map((item) => {
    const transformedItem = {
      key: item.id,
      label: item.name,
      children:
        item.children && item.children.length > 0
          ? transformData(item.children)
          : [],
    };

    return transformedItem;
  });
};

export const CategorySelect = ({
  categories,
  onSelectionChange,
}: CategorySelectProps) => {
  const { translate } = useTranslation(
    "pages.storeSecurity.restrictions.restrictedCategories.addDialog",
  );
  const [selectedNodeKey, setSelectedNodeKey] =
    useState<TreeCheckboxSelectionKeys | null>(null);

  const localCategories = useMemo(
    () => transformData(categories),
    [categories],
  );

  const handleChange = (e: TreeSelectionEvent) => {
    const newSelection = e.value as TreeCheckboxSelectionKeys;
    setSelectedNodeKey(newSelection);

    const selectedIds: string[] = [];

    // Go through the categrories and check if they are selected
    // If a category is selected, add it to the selectedIds array
    // If a category is partially selected, check its children
    // and add them to the selectedIds array
    categories.forEach((category) => {
      if (newSelection[category.id]?.checked) {
        selectedIds.push(category.id);
      } else if (newSelection[category.id]?.partialChecked) {
        category.children.forEach((child) => {
          if (newSelection[child.id]?.checked) {
            selectedIds.push(child.id);
          }
        });
      }
    });

    onSelectionChange(selectedIds);
  };

  return (
    <div className="card flex justify-content-center">
      <Tree
        value={localCategories}
        metaKeySelection={false}
        className="md:w-20rem w-full"
        selectionMode="checkbox"
        selectionKeys={selectedNodeKey}
        filterLocale="tr"
        onSelectionChange={handleChange}
        filter
        emptyMessage={translate("emptyCategory")}
      />
    </div>
  );
};
